var map = {
	"./EGLD.svg": 6956,
	"./HomepageIcon.svg": 53536,
	"./Icon-error.svg": 87700,
	"./Icon-user-alt.svg": 31604,
	"./QuestionFaq.svg": 84644,
	"./acceptButton.svg": 69544,
	"./activeArrow.svg": 25664,
	"./add.svg": 83196,
	"./arrow-ul.svg": 79477,
	"./auction.svg": 68756,
	"./backIcon.svg": 26940,
	"./bell.svg": 55900,
	"./browser.svg": 91232,
	"./cercle-ul.svg": 57224,
	"./charity.svg": 21204,
	"./chat.svg": 43640,
	"./check icon.svg": 52320,
	"./close.svg": 13424,
	"./club.svg": 97936,
	"./coming-soon.svg": 42684,
	"./cryptoAnimalBG.svg": 31364,
	"./dappIcon.svg": 84152,
	"./dark.svg": 33932,
	"./date icon.svg": 93692,
	"./discord.svg": 38100,
	"./download-disabled.svg": 21996,
	"./download.svg": 22268,
	"./edit icon.svg": 23944,
	"./edit.svg": 98819,
	"./elrd.svg": 28720,
	"./emptyHeart.svg": 69496,
	"./emptyLikeButton.svg": 86780,
	"./error icon.svg": 54884,
	"./export.svg": 70644,
	"./eye.svg": 42860,
	"./fb.svg": 55596,
	"./file-picture.svg": 8116,
	"./filledHeart.svg": 10284,
	"./filledLikeButton.svg": 70202,
	"./flag icon.svg": 29416,
	"./flag.svg": 39964,
	"./heart.svg": 94824,
	"./heartButton.svg": 7428,
	"./home-icon.svg": 10344,
	"./ic-add-3d.svg": 23056,
	"./ic-add-audio.svg": 75340,
	"./ic-add-video.svg": 18416,
	"./ic-delete.svg": 48112,
	"./ic-edit.svg": 29292,
	"./ic-gift.svg": 35536,
	"./ic-image.svg": 93100,
	"./ic-lock.svg": 72304,
	"./ic-unlock-3d.svg": 48252,
	"./ic-unlock-audio.svg": 46256,
	"./ic-unlock-video.svg": 52943,
	"./icon copy.svg": 5960,
	"./icon information.svg": 78492,
	"./icon instagram.svg": 51461,
	"./iconVu.svg": 6264,
	"./instagram.svg": 24295,
	"./instagramIcon.svg": 52400,
	"./inviteUser.svg": 71948,
	"./ledger-nano.svg": 85560,
	"./light.svg": 31636,
	"./logout icon orange.svg": 13156,
	"./logout icon white.svg": 33476,
	"./logout icon.svg": 13236,
	"./medium.svg": 4748,
	"./mediumIcon.svg": 72084,
	"./menuIcon.svg": 77204,
	"./message 01.svg": 15708,
	"./notfound.svg": 49240,
	"./notif.svg": 51780,
	"./notification 01.svg": 47048,
	"./notifications.svg": 26700,
	"./open.svg": 58314,
	"./orangenotifications.svg": 48456,
	"./orangesettings.svg": 40208,
	"./orangeshare.svg": 30472,
	"./orangeuser.svg": 64612,
	"./pic icon.svg": 53604,
	"./private.svg": 7676,
	"./privateCollection.svg": 22464,
	"./profil-logout.svg": 91428,
	"./profile button icon.svg": 84064,
	"./rarityLogo.svg": 90192,
	"./refresh.svg": 72624,
	"./refuseButton.svg": 87316,
	"./report.svg": 97144,
	"./rocket.svg": 73852,
	"./search icon.svg": 85290,
	"./searchIcon.svg": 15392,
	"./select icon.svg": 46044,
	"./settings.svg": 10600,
	"./share.svg": 74384,
	"./social link .svg": 37552,
	"./standard.svg": 2440,
	"./success icon.svg": 65028,
	"./telegram.svg": 7196,
	"./telegramChat.svg": 61176,
	"./telegramSound.svg": 72316,
	"./time icon.svg": 89900,
	"./twitter.svg": 83756,
	"./twitterBlue.svg": 55740,
	"./unactiveArrow.svg": 43128,
	"./unauthorized.svg": 85724,
	"./user profile.svg": 66284,
	"./user.svg": 11564,
	"./youtube.svg": 55975,
	"./zoominicon.svg": 23124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52564;